import { useNavigate } from "@tanstack/react-router";
import { Button } from "../components/ui/Button";

export function InvalidPad() {
  const navigate = useNavigate();

  return (
    <main className="grid min-h-screen place-items-center bg-neutral-50 p-6">
      <section className="w-full max-w-sm rounded-lg border border-neutral-200 bg-white p-6 shadow-[0_1px_2px_rgba(0,0,0,0.04),0_12px_40px_rgba(0,0,0,0.06)]">
        <h1 className="text-2xl font-semibold text-neutral-950">Invalid Slip link</h1>
        <p className="mt-2 text-sm leading-6 text-neutral-600">This Slip link is not supported.</p>
        <Button className="mt-5" variant="primary" onClick={() => navigate({ to: "/" })}>
          Open public Slip
        </Button>
      </section>
    </main>
  );
}
